import UserListing from './UserListing';

export default UserListing;
